import React, { useState } from "react";
import WhiteBgCard from "../../WhiteBgCard";
import AccountsDashboardCommonHeader from "../freshIntentSignals/AccountsDashboardCommonHeader";
import TopEngagedCard from "./TopEngagedCard";
import AccountsDashboardSeeAllModal from "../AccountsDashboardSeeAllModal";
import BorderBottomCard from "../../BorderBottomCard";

const TopEngaged = ({ accounts = [], isLoading = false, headerAction = null }) => {
  const [seeAllOpen, setSeeAllOpen] = useState(false);
  const allAccounts = accounts ?? [];
  const items = allAccounts.slice(0, 5);

  return (
    <WhiteBgCard className="p-4">
      <div className="flex flex-col gap-2.5">
        <AccountsDashboardCommonHeader
          title="Top Engaged"
          tooltipContent={
            <div className="space-y-1">
              <p>Engagement score follows the selected date range.</p>
              <p>+2 email open</p>
              <p>+5 email link click</p>
              <p>+2 LinkedIn/WhatsApp message read</p>
              <p>+8 LinkedIn connection</p>
              <p>+15 email/LinkedIn/WhatsApp reply</p>
              <p>A reply guarantees at least 16 points.</p>
              <p>Signals accumulate; score is capped at 100.</p>
              <p>Sent messages are not counted.</p>
            </div>
          }
          seeAllButtonText="See All"
          onSeeAll={() => setSeeAllOpen(true)}
          headerAction={headerAction}
        />
        <div className="max-h-[310px] w-full overflow-y-auto">
          {isLoading ? (
            <div className="flex flex-col w-full">
              {[1, 2, 3, 4, 5].map((i) => (
                <BorderBottomCard
                  key={i}
                  className="animate-pulse flex items-center justify-between gap-2"
                >
                  <div className="flex items-center gap-2 flex-1 min-w-0">
                    <div className="w-8 h-8 rounded-full bg-gray-200 shrink-0" />
                    <div className="flex flex-col gap-1.5 flex-1 min-w-0">
                      <div className="h-3 w-24 rounded bg-gray-200" />
                      <div className="h-2.5 w-32 rounded bg-gray-200" />
                    </div>
                  </div>
                  <div className="w-14 h-5 rounded-full bg-gray-200 shrink-0" />
                </BorderBottomCard>
              ))}
            </div>
          ) : items.length === 0 ? (
            <p className="text-[0.8rem] text-gray-500 dark:text-gray-400 py-8 text-center min-h-[270px] w-full flex items-center justify-center">
              No engaged accounts yet.
            </p>
          ) : (
            items.map((account, index) => (
              <TopEngagedCard
                key={
                  account?.account_id ??
                  account?.company_name ??
                  `engaged-${index}`
                }
                account={account}
              />
            ))
          )}
        </div>
      </div>
      <AccountsDashboardSeeAllModal
        isOpen={seeAllOpen}
        onClose={() => setSeeAllOpen(false)}
        variant="top_engaged"
        title="Top engaged accounts"
        description={
          "Accounts ranked by weighted engagement score from opens, reads, clicks, and replies in the selected date range."
        }
        items={allAccounts}
      />
    </WhiteBgCard>
  );
};
export default TopEngaged;
